import { render } from "./WebmasterSidebar.vue?vue&type=template&id=46c63024"
import script from "./WebmasterSidebar.vue?vue&type=script&lang=js"
export * from "./WebmasterSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__